export const WIDGET_PUBLICATION_ACTION = Object.freeze({
  PROMOTE_GENERATION: 'promote_generation',
  PUBLISH_WIDGET: 'publish_widget',
});

export function widgetPublicationAction({ widget, run }) {
  if (run?.builder_state?.state === 'ready_to_publish') {
    return WIDGET_PUBLICATION_ACTION.PROMOTE_GENERATION;
  }

  if (!widget || widget.template_legacy_pinned || !['draft', 'published'].includes(widget.status)) return null;

  const needsPublication = widget.status === 'draft' || widget.highest_version !== widget.published_version;
  if (!needsPublication) return null;

  if (widget.template_runtime_state != null) {
    return widget.template_runtime_state === 'unpublished' ? WIDGET_PUBLICATION_ACTION.PUBLISH_WIDGET : null;
  }

  return widget.preview_url && widget.preview_height ? WIDGET_PUBLICATION_ACTION.PUBLISH_WIDGET : null;
}
